import {useEffect} from 'react';
import type {UseQueryResult} from '@tanstack/react-query';

export type UseReactQueryAutoListUtilsParams = {
	isOpen: boolean;
	clearOptions: boolean;
	query: UseQueryResult<any, unknown>;
	queryIsValid: boolean;
};

export const useReactQueryAutoListUtils = ({
	clearOptions,
	isOpen,
	query,
	queryIsValid,
}: UseReactQueryAutoListUtilsParams) => {
	const loadingOptions =
		isOpen && queryIsValid && (query.isLoading || query.isFetching);

	useEffect(() => {
		// when queryStr is empty, remove the query data
		if (clearOptions) query.remove();
	}, [clearOptions]);

	useEffect(() => {
		return () => {
			query.remove();
		};
	}, []);

	return {
		loadingOptions,
		clearOptions,
	};
};
